/**
 * Dados de atribuição de campanha capturados no momento do cadastro do cliente.
 *
 * A separação entre os dois grupos abaixo não é cosmética: ela reflete onde
 * cada campo consegue ser persistido no Vectis (ED-7201).
 */

/**
 * Campos que o Vectis já tem coluna dedicada em `hclinica.cliente` e que são
 * enviados na raiz do `PUT /clientes` (`utmsource`, `utmmedium`, `utmcampaign`,
 * `utmterm`, `facebookid`, `googleid`, `googleidtype`, `eventoconversaolead`).
 */
export type TTrackingMetaColumns = {
  nomeEvento?: string;
  source?: string;
  medium?: string;
  campaign?: string;
  term?: string;
  facebookId?: string;
  googleId?: string;
  googleIdType?: string;
  ip?: string;
};

/**
 * Campos sem coluna correspondente no Vectis. Vão para `origemLead.extra`, que
 * é um `jsonb` livre e preserva chaves arbitrárias.
 *
 * Como `origemLead.extra` é o único destino possível para eles, o cadastro só
 * consegue carregá-los se informar a origem do lead — por isso `leadOrigin` é
 * obrigatório ao criar um cliente, e não opcional.
 */
export type TTrackingMetaExtras = {
  content?: string;
  referrer?: string;
};

export type TTrackingMeta = TTrackingMetaColumns & TTrackingMetaExtras;

export const TRACKING_META_EXTRA_KEYS: Array<keyof TTrackingMetaExtras> = [
  'content',
  'referrer',
];
